import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import CampaignListScreen from "../screens/CampaignListScreen";

import MadListScreen from "../screens/MadListScreen";
import NewMadScreen from "../screens/NewMadScreen";
import EditMadScreen from '../screens/EditMadScreen';
import UserFollowUpScreen from "../screens/UserFollowUpScreen";

type MadsRouterProps = RouteComponentProps;

const MadsRouter: React.FC<MadsRouterProps> = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}/new`} component={NewMadScreen} />

    <Route exact path={`${match.path}/campaigns`} component={CampaignListScreen} />

    <Route exact path={`${match.path}/next`} component={MadListScreen} />
    <Route exact path={`${match.path}/ongoing`} component={MadListScreen} />
    <Route exact path={`${match.path}/finished`} component={MadListScreen} />
    <Route exact path={`${match.path}/available`} component={MadListScreen} />

    <Route path={`${match.path}/new`} component={NewMadScreen} />
    <Route exact path={`${match.path}/:id/edit`} component={EditMadScreen} />
    <Route exact path={`${match.path}/:id`} component={UserFollowUpScreen} />
    <Route exact path={`${match.path}`} component={MadListScreen} />
  </Switch>
);

export default MadsRouter;
